import { render, staticRenderFns } from "./RotateSquare4.vue?vue&type=template&id=10c5d491&scoped=true&"
import script from "./RotateSquare4.vue?vue&type=script&lang=js&"
export * from "./RotateSquare4.vue?vue&type=script&lang=js&"
import style0 from "./RotateSquare4.vue?vue&type=style&index=0&id=10c5d491&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5d491",
  null
  
)

export default component.exports